import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=2dc7ffde&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
import style0 from "./Login.vue?vue&type=style&index=0&id=2dc7ffde&prod&scoped=true&style=less&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc7ffde",
  null
  
)

export default component.exports